import { compact } from "@lana-commerce/core/compact";

import { CategoryBrief, ShopData } from "../data/def";
import { ProductFragment } from "../graphql/types";
import { getCategoryChain } from "./getCategoryChain";
import { useShopData } from "../data/shopData";

export function getProductCategories(shopData: ShopData, product: ProductFragment): CategoryBrief[] {
  const catChains = compact(
    product.categories?.map((c) => (c ? getCategoryChain(shopData.categories, c.id) : undefined))
  )
    .map((cc) => {
      return {
        catChain: cc,
        numFeatured: cc.reduce((cnt, c) => cnt + (c.featured ? 1 : 0), 0),
      };
    })
    .sort((a, b) => b.numFeatured - a.numFeatured);
  return catChains.length > 0 ? catChains[0].catChain : [];
}

/**
 * Get a chain of product categories with most featured categories.
 * Featured category is the one for which we generate a real frontend page.
 * Thus this function is well suited for making product breadcrumbs.
 * As it will feature most clickable categories.
 */
export function useProductCategories(product: ProductFragment): CategoryBrief[] {
  const shopData = useShopData();
  return getProductCategories(shopData, product);
}
